import { render, staticRenderFns } from "./ProfileEventRow.vue?vue&type=template&id=5d6ebbb1&scoped=true"
import script from "./ProfileEventRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileEventRow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileEventRow.vue?vue&type=style&index=0&id=5d6ebbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ebbb1",
  null
  
)

export default component.exports